document.addEventListener('DOMContentLoaded', function() {
  const DESKTOP_Q = '(min-width: 990px) and (pointer: fine) and (hover: hover)';
  const CLOSE_DELAY = 120; // ms

  function isDesktop() {
    return window.matchMedia(DESKTOP_Q).matches;
  }

  function setupHover() {
    // Only target nav menu summaries, NOT header actions (search, hamburger)
    const summaries = document.querySelectorAll('nav.header__inline-menu summary');

    summaries.forEach(summary => {
      if (summary.__hoverInited) return;
      summary.__hoverInited = true;

      const details = summary.closest('details');
      if (!details) return;

      const submenu = summary.nextElementSibling;
      let closeTimer;

      function open() {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      }

      function scheduleClose() {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      }

      // Open on hover over summary
      summary.addEventListener('pointerenter', open);

      // Keep open while hovering inside submenu
      if (submenu) {
        submenu.addEventListener('pointerenter', open);
        submenu.addEventListener('pointerleave', scheduleClose);
      }

      // Close when leaving the entire <details> block
      details.addEventListener('pointerleave', scheduleClose);

      // Prevent click toggling on desktop (summary only)
      summary.addEventListener('click', function(e) {
        if (!isDesktop()) return;
        e.preventDefault();
      });
    });
  }

  function hideCarets() {
    const carets = document.querySelectorAll(
      'nav.header__inline-menu summary svg.icon-caret, ' +
      'nav.header__inline-menu summary .icon-caret, ' +
      'nav.header__inline-menu summary .icon--caret'
    );
    carets.forEach(caret => {
      caret.style.display = 'none';
    });
  }

  setupHover();
  hideCarets();

  // Re-init on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      setupHover();
      hideCarets();
    }, 200);
  });
});
